import { render, staticRenderFns } from "./application-record.vue?vue&type=template&id=b5106b8a&scoped=true&"
import script from "./application-record.vue?vue&type=script&lang=js&"
export * from "./application-record.vue?vue&type=script&lang=js&"
import style0 from "./application-record.vue?vue&type=style&index=0&id=b5106b8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5106b8a",
  null
  
)

export default component.exports